import request from '@/utils/request';

const baseURLAdmin = process.env.VUE_APP_ADMIN;
const baseUserURL = process.env.VUE_APP_USER; // /user

/**
 * 内部时效管理--内部时效 - 文件导入
 */
export const batchImport = (file) => {
  return request({
    url: '/InternalAging/batchImport',
    method: 'POST',
    data: file,
    baseURL: baseURLAdmin
  });
};

/**
 * 客户新增
 * @param data
 * @returns
 */
export const apiCustomerAdd = (data) => {
  // return request.post('/customer/add', data);
  return request({
    method: 'post',
    data,
    url: `/customer/add`,
    baseURL: baseURLAdmin,
    router: {
      operateMenu: '客户列表',
      requestArgs: data,
      operateButton: '新增客户信息'
    }
  });
};

/**
 * 客户 账户名校验
 * @param data
 * @returns
 */
export const apiCustomerCheck = (data) => {
  return request({
    url: '/customer/check',
    method: 'get',
    params: { ...data }
  });
};

/**
 * 客户修改
 * @param data
 * @returns
 */
export const apiCustomerEdit = (data) => {
  // eslint-disable-next-line no-undef
  // return request.put(`/customer/${data.id}`, data);
  return request({
    method: 'put',
    data,
    url: `/customer/${data.id}`,
    baseURL: baseURLAdmin,
    router: {
      operateMenu: '客户列表',
      requestArgs: data,
      operateButton: '编辑客户信息'
    }
  });
};

// 客户修改FTP
export const apiCustomerEditFtp = (data) => {
  // return request.put('customer/updateFtpInfo/' + data.id, data);
  return request({
    method: 'put',
    data,
    url: 'customer/updateFtpInfo/' + data.id,
    baseURL: baseURLAdmin,
    router: {
      operateMenu: '客户列表',
      requestArgs: data,
      operateButton: '修改FTP'
    }
  });
};

export const apiCustomerEditOther = (data) => {
  // return request.put('customer/addOrUpdateOtherInfo', data);
  return request({
    method: 'put',
    data,
    url: '/customer/addOrUpdateOtherInfo',
    baseURL: baseURLAdmin,
    router: {
      operateMenu: '客户列表',
      requestArgs: data,
      operateButton: '其他设置'
    }
  });
};

/**
 * 客户列表
 */
export const apiCustomerPage = (data, isBool = true) => {
  // return request.post('/user/customer/page', data);
  return request({
    method: 'POST',
    data,
    url: `/customer/page`,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseURLAdmin
  });
};
export const apiCustomerListPage = (data, isBool = true) => {
  // return request.post('/user/customer/page', data);
  return request({
    method: 'POST',
    data,
    url: `/customer/page`,
    isLoading: isBool, // 是否显示加载中参数
    router: {
      operateMenu: '客户列表',
      requestArgs: data,
      operateButton: '查询'
    },
    baseURL: baseURLAdmin
  });
};
/**
 * 客户列表 ==> dxk
 */
export const CustomerPage = (data, isBool = true) => {
  return request({
    url: '/customer/customerPage',
    method: 'post',
    data,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseURLAdmin
  });
};
// 获取所有客户
export const apiCustomerList = (data, isBool = true) => {
  return request({
    method: 'POST',
    data,
    url: `/user/customer/list`,
    isLoading: isBool // 是否显示加载中参数
  });
  // return request.post('/user/customer/list', data);
};

/**
 * 根据客户id查询客户详细信息
 */
export const apiCustomerFindById = (ids) => {
  // return request.post('/user/customer/findById', data);
  return request({
    url: `/customer/findById/${ids}`,
    method: 'get',
    baseURL: baseURLAdmin,
    router: {
      operateMenu: '客户列表',
      requestArgs: ids,
      operateButton: '查看详情'
    }
  });
};

/**
 * 状态控制
 */
export const apiCustomerStateHandler = (data) => {
  // return request.post('/customer/stateHandler', data);
  return request({
    method: 'post',
    data,
    url: `/customer/stateHandler`,
    baseURL: baseURLAdmin,
    router: {
      operateMenu: '客户列表',
      requestArgs: data,
      operateButton: data.type === 1 ? '账户启用' : '账户停用'
    }
  });
};

// 获取所有客户渠道
export const apiCustomerChannellist = (data, isBool = true) => {
  return request({
    method: 'post',
    data,
    url: `/logistics/customerChannel/list`,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 获取当前客户的所有客户渠道
export const apiListByCustomerId = (ids, isBool = true) => {
  return request({
    method: 'get',
    url: `/customerChannelConfig/listByCustomerId/${ids}`,
    isLoading: isBool // 是否显示加载中参数
  });
  // return request.get(`user/customerChannelConfig/listByCustomerId/${ids}`);
};

// 保存客户渠道配置
export const apiCustomerChannelConfigAdd = (data) => {
  return request.post('/user/customerChannelConfig/add', data);
};

// 更新客户渠道配置
export const apiCustomerChannelConfigEdit = (data) => {
  return request.post('/user/customerChannelConfig/edit', data);
};

// 获取客户跟进信息
export const apiCustomerFollow = (ids) => {
  return request.get(`customerFollow/listByCustomerId/${ids}`);
};

// 新增客户跟进说明
export const apiCustomerFollowAdd = (data) => {
  return request.post('/user/customerFollow/add', data);
};

// 新增客户跟进说明
export const apiCustomerFollowDel = (ids) => {
  return request.put(`/user/customerFollow/delete/${ids}`);
};

// 获取授权码
export const apiGetAuthorizationCode = (ids) => {
  return request({
    method: 'get',
    url: `/customer/getAuthorizationCode/${ids}`,
    baseURL: baseURLAdmin,
    router: {
      operateMenu: '客户列表',
      requestArgs: ids,
      operateButton: '获取授权码'
    }
  });
};

/**
 * 重置密码
 */
export const apiResetPassword = (data) => {
  // return request.post('/customer/resetPassword', data);
  return request({
    method: 'post',
    url: `/customer/resetPassword`,
    baseURL: baseURLAdmin,
    data,
    router: {
      operateMenu: '客户列表',
      requestArgs: data,
      operateButton: '重置密码'
    }
  });
};

// 获取寄件人列表
// export const apiGetSendList = (data, isBool = true) => {
//   return request({
//     method: 'post',
//     data,
//     url: `/logistics/addressBook/getList`,
//     isLoading: isBool // 是否显示加载中参数
//   });
// };
// 充值余额
export const billRecharge = (data) => {
  return request.post('/fa/bill/recharge?amount=' + data.amount + '&customerId=' + data.customerId);
};
// 修改信用额度
export const changeCreditLimit = (data) => {
  return request.post(
    '/fa/bill/changeCreditLimit?creditLimit=' + data.creditLimit + '&customerId=' + data.customerId
  );
};
export const queryAllUser = (data) => {
  return request({
    method: 'POST',
    data,
    url: `/queryAllUserPage`,
    baseURL: baseUserURL
  });
};
// 客户时效
export const localAgingGetConfigPage = (data) => {
  // return request.post(`/localAging/getConfigPage`, data, {
  //   baseURL: baseURLAdmin
  // });
  return request({
    method: 'POST',
    data,
    url: `/localAging/getConfigPage`,
    baseURL: baseURLAdmin
  });
};
// 客户时效
export const localAgingupdateStatus = (data) => {
  // return request.post(`/localAging/updateStatus`, data, {
  //   baseURL: baseURLAdmin
  // });
  return request({
    method: 'POST',
    data,
    url: `/localAging/updateStatus`,
    baseURL: baseURLAdmin
  });
};
// 客户时效
export const localAgingdownload = (id) => {
  // return request.get(`/localAging/download/${id}`, {
  //   baseURL: baseURLAdmin
  // });
  return request({
    method: 'get',
    url: `/localAging/download/${id}`,
    baseURL: baseURLAdmin
  });
};
// 新增客户时效
export const localAgingAdd = (data) => {
  return request({
    method: 'POST',
    data,
    url: `/localAging/add`,
    headers: {
      'Content-Type': 'multipart/form-data' // 设置 Content-Type
    },
    baseURL: baseURLAdmin
  });
};
// 客户时效
export const localAgingdownloadmodule = () => {
  return request({
    method: 'get',
    url: `/localAging/download/module`,
    responseType: 'blob',
    baseURL: baseURLAdmin
  });
};
// 客户时效
export const timelinessdownloadmodule = () => {
  return request({
    method: 'get',
    url: `/timeliness/transport/download/module`,
    responseType: 'blob'
  });
};
// 客户时效
export const localproblemList = (data) => {
  return request({
    url: '/localCustomer/problem/pageList',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 查询问题件原因
export const getproblemList = () => {
  // return request.get(`/localCustomer/problem/problemType/list?keyword=${''}`);
  return request({
    method: 'get',
    url: `/localCustomer/problem/problemType/list?keyword=${''}`,
    baseURL: baseURLAdmin
  });
};
// 查询本地客户数据
export const getproblemcustomerList = () => {
  return request({
    method: 'get',
    url: `/localCustomer/problem/customer/list?keyword=${''}`,
    baseURL: baseURLAdmin
  });
};
// 查询本地客户数据  释放问题件拦截
export const liftInterceptType = (data) => {
  // return request.post(`/packageWhetherIntercept/liftInterceptType`, data);
  return request({
    url: '/packageWhetherIntercept/liftInterceptType',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 查询本地客户数据  释放10天限制
export const releaseTenDaysIntercept = (data) => {
  // return request.post(`/packageWhetherIntercept/releaseTenDaysIntercept`, data);
  return request({
    url: '/packageWhetherIntercept/releaseTenDaysIntercept',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 修改客户时效
export const localAgingEdit = (data) => {
  return request({
    method: 'POST',
    data,
    url: `/localAging/modify`,
    headers: {
      'Content-Type': 'multipart/form-data' // 设置 Content-Type
    },
    baseURL: baseURLAdmin
  });
};
// 商户管理
export const getMerchantByCustomerId = (customerId) => {
  return request.get(`/customerMerchant/getMerchantByCustomerId/${customerId}`);
};
export const apiCustomerPageList = (val, isBool = true) => {
  return request({
    method: 'get',
    url: `/customerMerchant/getMerchantList?merchantName=${val}`,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseURLAdmin
  });
};
// 配合远程搜索
export const getMerchantByCustomerIdSearch = (customerId, val) => {
  return request.get(`/customerMerchant/getMerchantByCustomerId/${customerId}?merchantName=${val}`);
};
export const apiCustomerPageList01 = (customerId, val, isBool = true) => {
  return request({
    method: 'get',
    url: `/customerMerchant/getMerchantAgingList?customerId=${customerId}&merchantName=${val}`,
    isLoading: isBool, // 是否显示加载中参数
    baseURL: baseURLAdmin
  });
};
export const getMerchantByCustomerId01 = (customerId, val) => {
  return request({
    url: `/customerMerchant/getMerchantAgingList?customerId=${customerId}&merchantName=${val}`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// 获取商户名称
export const apimerchantName = (data) => {
  return request({
    url: '/customerMerchant/pageMerchantNameQuery',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
/**
 * 客户列表 ==> 内部时效管理-列表查询
 */
export const getConfigPage = (data) => {
  return request({
    url: '/InternalAging/getConfigPage',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
/**
 * 客户列表 ==> 内部时效管理 - 新增
 */
export const InternalAgingAdd = (data) => {
  return request({
    url: '/InternalAging/add',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
/**
 * 客户列表 ==> 内部时效管理 - 修改
 */
export const InternalAgingModify = (data) => {
  return request({
    url: '/InternalAging/modify',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
/**
 * 客户列表 ==> 内部时效管理 - 修改
 */
export const InternalAgingUpdateStatus = (data) => {
  return request({
    url: '/InternalAging/updateStatus',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
/**
 * 客户列表 ==> 内部时效管理 - 下载时效
 */
export const InternalAgingUDownload = (id) => {
  return request({
    url: `/InternalAging/download/${id}`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// 客户列表 ==> 内部时效管理 - 下载文件模版
export const InternalAgingDownloadmodule = () => {
  return request({
    method: 'get',
    url: `/InternalAging/download/module`,
    responseType: 'blob',
    baseURL: baseURLAdmin
  });
};
// 上报人员 下拉框
export const getUserPage = (data) => {
  return request({
    method: 'post',
    data,
    url: '/getUserPage',
    baseURL: baseUserURL
  });
};
// 获取运单时效的更新时间
export const getLastSyncTime = () => {
  return request({
    url: `/orderWaybillTimeRecord/getLastSyncTime`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};
